module.exports = __webpack_public_path__ + "img/Maintenance and repairs.f078cbe1.svg";